import { useLocation } from "wouter";
import { useFeatureFlags } from "@/hooks/use-feature-flags";
import { KUALOA_LEGACY_SLUG, KUALOA_PROPERTY_SLUG, KUALOA_STAY_PATH } from "@shared/property-context";

/**
 * Where "Book Now" should go from the page the visitor is on.
 *
 * On a home's own pages it books that home. On the Kualoa booking page and
 * its legacy hub pages it stays with the Kualoa house. Everywhere else, with
 * more than one home listed, it goes to Our Homes so the visitor chooses a
 * home first; a single-home site keeps the old booking page.
 */
export function useBookCta(): { href: string; label: string; choosing: boolean } {
  const [location] = useLocation();
  const flags = useFeatureFlags();
  const portfolio = flags.portfolioHomepage && flags.publishedHomeCount > 1;
  const kualoaBook = flags.propertyRoutes ? `${KUALOA_STAY_PATH}/book` : "/booking";

  const own = location.match(/^\/properties\/([^/]+)(?:\/|$)/);
  if (own && own[1] !== KUALOA_LEGACY_SLUG) {
    const slug = own[1] === KUALOA_PROPERTY_SLUG ? KUALOA_PROPERTY_SLUG : own[1];
    return { href: `/properties/${slug}/book`, label: "Book Now", choosing: false };
  }
  if (location === "/booking" || location.startsWith("/booking/") || location === "/stay" || location === "/reviews") {
    return { href: location.startsWith("/booking") ? "/booking" : kualoaBook, label: "Book Now", choosing: false };
  }
  // /booking opens the booking lightbox on its home chooser (and without
  // script it still lands on Our Homes, where /booking redirects).
  if (portfolio) return { href: "/booking", label: "Check Availability", choosing: true };
  return { href: "/booking", label: "Book Now", choosing: false };
}
